import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useGlobalStyles = makeStyles((theme: Theme) => ({
  noMargin: {
    margin: 0,
  },
  screenContainer: {
    width: '100%',
    position: 'relative',
    maxWidth: theme.custom?.mainContentMaxWidth,
    padding: theme.spacing(10),
    paddingTop: theme.spacing(7.5),
    paddingBottom: theme.spacing(7.5),
    marginLeft: 'auto',
    marginRight: 'auto',
    zIndex: 1,
  },
  roundCornersBottom: {
    borderBottomLeftRadius: 40,
    borderBottomRightRadius: 40,
  },
  roundCornersTop: {
    borderTopLeftRadius: 40,
    borderTopRightRadius: 40,
  },
  squareCornersBottom: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  squareCornersTop: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  screenContainerMobile: {
    padding: theme.spacing(1),
  },
  screenContainerMobileVerticalPadding: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  screenContainerMobileHorizontalPadding: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  textBright: {
    color: '#fff',
  },
  gridTopMarginFix: { // todo - fix grid
    marginTop: 0,
  },
  paperContainer: { // todo - should there be a shared component?
    padding: theme.spacing(3),
  },
  paperContainerInline: {
    display: 'inline-block',
  },
  inlineBlock: {
    display: 'inline-block',
  },
  icon: {
    '& path': {
      fill: '#000',
      // path: '#000',
    },
  },
  iconLight: {
    '& path': {
      fill: '#fff',
      // path: '#fff',
    },
  },
  iconXs: {
    height: theme.typography.fontSize,
    width: theme.typography.fontSize,
  },
  iconSm: {
    height: theme.typography.fontSize * 1.333,
    width: theme.typography.fontSize * 1.333,
  },
  iconMd: {
    height: theme.typography.fontSize * Math.pow(1.333, 2),
    width: theme.typography.fontSize * Math.pow(1.333, 2),
  },
  iconLg: {
    height: theme.typography.fontSize * Math.pow(1.333, 3),
    width: theme.typography.fontSize * Math.pow(1.333, 3),
  },
  iconXl: {
    height: theme.typography.fontSize * Math.pow(1.333, 4),
    width: theme.typography.fontSize * Math.pow(1.333, 4),
  },
  marginTop0: {
    marginTop: 0,
  },
  paddingTop0: {
    paddingTop: '0 !important',
  },
  // margin top spacings
  marginTopTiny: {
    marginTop: theme.spacing(1),
  },
  marginTopSmall: {
    marginTop: theme.spacing(3),
  },
  marginTopMedium: {
    marginTop: theme.spacing(6),
  },
  // margin bottom spacings
  marginBottomTiny: {
    marginBottom: theme.spacing(1),
  },
  marginBottomSmall: {
    marginBottom: theme.spacing(3),
  },
  marginBottomMedium: {
    marginBottom: theme.spacing(6),
  },
  // margin left spacings
  marginLeftTiny: {
    marginLeft: theme.spacing(1),
  },
  marginLeftSmall: {
    marginLeft: theme.spacing(3),
  },
  marginLeftMedium: {
    marginLeft: theme.spacing(6),
  },
  // margin right spacings
  marginRightTiny: {
    marginRight: theme.spacing(1),
  },
  marginRightSmall: {
    marginRight: theme.spacing(3),
  },
  marginRightMedium: {
    marginRight: theme.spacing(6),
  },
  // align Text
  alignTextCenter: { // todo rename to textAlign
    textAlign: 'center',
  },
  alignTextRight: {
    textAlign: 'right',
  },
  alignTextLeft: {
    textAlign: 'left',
  },
  // alignment with margin
  alignSelfLeft: {
    marginLeft: 0,
    marginRight: 'auto',
  },
  alignSelfRight: {
    marginLeft: 'auto',
    marginRight: 0,
  },

  italic: {
    fontStyle: 'italic',
  },
  // flex
  flex: {
    display: 'flex',
  },
  flexJustifyCenter: {
    justifyContent: 'center',
  },
  flexJustifyCenterImportant: {
    justifyContent: 'center !important',
  },
  flexAlignCenter: {
    alignItems: 'center',
  },

  // logo
  logoBig: {
    maxHeight: 100,
  },

  // misc
  fullWidth: {
    width: '100%',
  },
  fullMaxWidth: {
    maxWidth: '100%',
  },
  fullHeight: {
    height: '100%',
  },
  fullViewHeight: {
    height: '100vh',
  },
  skeletonText: {
    maxWidth: '300px',
  },
  // todo - maybe outsurce this to where its needed
  transparentInput: {
    backgroundColor: 'transparent !important',
  },
  imageOverlay: {
    position: 'absolute',
    height: '100vh',
    width: '100%',
    overflow: 'hidden',
    top: 0,
    zIndex: 0,
  },
  imageOverlayTablet: {
    position: 'relative',
    height: 'auto',
  },
  radiusBackground: {
    minHeight: '120vh',
    backgroundColor: theme.palette.common.black,
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
    top: '-10vh',
    borderBottomLeftRadius: '50%',
    borderTopLeftRadius: '50%',
    marginLeft: '50%',
  },
  radiusBackgroundTablet: {
    position: 'relative',
    minHeight: 'initial',
    height: 'auto',
    marginLeft: 0,
    top: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  biggerImage: {
    '& img': {
      maxWidth: '114%',
      marginLeft: '-14%',
    },
  },
}))
